import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DISPLAY_PIPE_DATE_FORMAT } from '@monorepo/utils';

@Component({
  selector: 'ui-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
})
export class LabelComponent {
  @Input() displayStr: string | number = '';
  @Input() type?: 'DATE';
  @Input() preTagForDataDisplay?: boolean = false;
  @Input() readonly = false;

  @Output() removeFilterEvent = new EventEmitter<null>();

  PIPE_DATE_FORMAT = DISPLAY_PIPE_DATE_FORMAT;

  onRemove() {
    this.removeFilterEvent.emit();
  }
}
